import { useAppSelector } from 'store/store';
import { ROLE_TENANT_TECHNICIAN } from 'shared/permissions/roles';

export function IsTenantTechican({ children }) {
  const groups = useAppSelector((state) => state.auth.groups);
  if (groups && groups.includes(ROLE_TENANT_TECHNICIAN)) return children;
}
